import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Income from "@/pages/Income";
import Expenses from "@/pages/Expenses";
import BankAccounts from "@/pages/BankAccounts";
import Contacts from "@/pages/Contacts";
import UpcomingPayments from "@/pages/UpcomingPayments";
import UpcomingReceivables from "@/pages/UpcomingReceivables";
import Employees from "@/pages/Employees";
import Overtime from "@/pages/Overtime";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import { useAuth } from "@/context/AuthContext";
import "@/App.css";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function AdminOnly({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/gelirler" element={<Protected><Income /></Protected>} />
          <Route path="/giderler" element={<Protected><Expenses /></Protected>} />
          <Route path="/banka" element={<Protected><BankAccounts /></Protected>} />
          <Route path="/cariler" element={<Protected><Contacts /></Protected>} />
          <Route path="/odemeler" element={<Protected><UpcomingPayments /></Protected>} />
          <Route path="/tahsilatlar" element={<Protected><UpcomingReceivables /></Protected>} />
          <Route path="/calisanlar" element={<Protected><Employees /></Protected>} />
          <Route path="/mesai" element={<Protected><Overtime /></Protected>} />
          <Route path="/raporlar" element={<Protected><Reports /></Protected>} />
          <Route path="/kullanicilar" element={<Protected><AdminOnly><Users /></AdminOnly></Protected>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
